module.exports = __webpack_public_path__ + "img/catedral.e44e32ac.jpg";